// Onboarding feature flag + constants. Default ON. (No Remote Config in repo.)
export const ONBOARDING_ENABLED = true;

// Schema version — bump if the shape of the onboarding object changes.
// v2: collectorTypes[] (multi-select) replaces singular collectorType.
export const ONBOARDING_VERSION = 2;

// Total interactive rounds (R1–R5). Finish is a transition, not a round.
export const TOTAL_ROUNDS = 5;

// If a set with this name exists in the shelf, pin it first (newest-first otherwise).
export const PINNED_SET_NAME_MATCH = /knockout/i; // 2026 Topps Knockout UFC, plain text

export const COLLECTOR_TYPES = ['set_builder', 'rainbow_chaser', 'fighter_pc', 'rookie_hunter', 'hits'];

const onboardingConfig = {
  ONBOARDING_ENABLED,
  ONBOARDING_VERSION,
  TOTAL_ROUNDS,
  PINNED_SET_NAME_MATCH,
  COLLECTOR_TYPES,
};

export default onboardingConfig;
